


























import Vue from 'vue'
import Component from 'vue-class-component'
import { AppModule } from '@app/componentlib/src/store/modules/app'
import { IFilterItem } from '@app/componentlib/common/types/JobSearchTypes'

@Component<SearchFilterDropdown>({
  props: {
    title: String,
    filterArray: Array,
    chosenArray: Array
  }
})

export default class SearchFilterDropdown extends Vue {
  /**
   * Props variables
   */
  title: string | undefined
  filterArray: IFilterItem[] | undefined
  chosenArray: string[] | undefined


  /**
   * Component state variables
   */


  /**
   * Lifecycle
   */


  /**
   * Getters
   */
  get t (): any {
    return AppModule.translations
  }

  /**
   * Methods
   */
   changeShowOverlay(e: any) {
    this.$emit('changeShowOverlay', e.type === "show" ? true : false)
  }

  clickedItemFilter(item: string) {
    console.log("filter clicked", item)
    this.$emit('clickedItemFilter', item)
  }

  startSearch() {
    this.$emit('startSearch')
  }
}
